import CopyWebpackPlugin from 'copy-webpack-plugin'

const path = require('path')

module.exports = function (state, opts, config) {
    const FURTHER_REF = state.FURTHER_REF
    const OUTPUT_PATH = state.OUTPUT_PATH
    return new CopyWebpackPlugin([
        {
            // copying the SERVER STARTER file
            from: path.join(FURTHER_REF, '../dist/tpls/server/', 'further-http-server.js'),
            to: path.join(OUTPUT_PATH, 'server/index.js'),
            ignore: ['**/**/.DS_Store', '**/**/.gitkeep'],
            transform: (content) => {
                // replacing some marks/tokens
                content = content.toString()
                content = content.replace("${DEV_SERVER_PORT}", opts.server ? opts.server.port || 'null' : 'null')
                return Buffer.from(content, 'utf8')
            }
        },
        {
            // copying the SERVER STARTER file
            from: path.join(FURTHER_REF, '../dist/tpls/server/', 'redirect.html'),
            to: path.join(OUTPUT_PATH, 'client/index.html'),
            ignore: ['**/**/.DS_Store', '**/**/.gitkeep'],
            // transform: (content) => {
            //     // replacing some marks/tokens
            //     content = content.toString()
            //     content = content.replace("${DEV_SERVER_PORT}", opts.server ? opts.server.port || 'null' : 'null')
            //     return Buffer.from(content, 'utf8')
            // }
        }
  ])
}


// WEBPACK FOOTER //
// ./src/technologies/http.js